<template>
    <div class="tkank-note">
        <giveawayModal v-if="giveawayModalSettings !== null" :settings="giveawayModalSettings"></giveawayModal>
        <publicReviewPopup :settings="publicReviewPopupSettings"></publicReviewPopup>
        <profileIcon :settings="profileIconSettings"></profileIcon>
        <div v-if="testTemplateBlocksEnabled" style="height: 70px; background-color: #6D6D6D; width: 100%;"></div>
        <div class="top-block">
            <div class="logo" @click="onAirVoteLogoClick">
                <img alt="logo" src="@/assets/icons/logo_mini.svg" class="bad">
            </div>
            <div class="place">
                <div class="place_img" @click="onPlaceImageClick()">
                    <img v-if="place_img.length != 0" :src="place_img" alt="place img">
                    <img v-else src="@/assets/re/default_place_img.jpg" alt="place img">
                </div>
            </div>
            <div class="place_name" @click="onPlaceNameClick()">{{place_info.place.name}}</div>
            <div class="question" @click="onQuestionNameClick">{{place_info.question}}</div>

            <p class="thank-title-1">{{translate('thankVoteTitle1')}}!</p>
            <p class="thank-title-2">
                <span>{{translate('thankVoteTitle2_1')}}!</span>
            </p>
            <div class="thank-title-2 m-k" v-if="giveaway && giveaway.enabled && giveaway.giveaway_title == 'm&k'"><span>Join our giveaway contest below to win $150 cash</span></div>
        </div>

        <div class="bottom-button-group">
            <div class="socialReviewWrapper">
                <div class="socialReview__block" v-if="rate_id == 3">
                    <div class="block-btn__wrapper" v-for="(link, index) in place_info.place.links.slice(0, 3)"
                         :key="index"
                         @click="openSocialLink(link)">
                        <div class="block-btn">
                            <img alt="" src="@/assets/icons/ic_facebook_color.svg" v-if="link.network.id == 1">
                            <img alt="" src="@/assets/icons/ic_yelp.svg" v-if="link.network.id == 2">
                            <img alt="" src="@/assets/icons/ic_google.svg" v-if="link.network.id == 3">
                            <img alt="" src="@/assets/icons/ic_tripadvisor_color.svg" v-if="link.network.id == 4">
                            <img alt="" src="@/assets/icons/ic_vk_color.svg" v-if="link.network.id == 6">
                            <img alt="" src="@/assets/icons/ic_instagram_color.svg" v-if="link.network.id == 5">
                            <img alt="" src="@/assets/icons/ic_web_color.svg" v-if="link.network.id == 7">
                            <img alt="" src="@/assets/icons/ic_donate.svg" v-if="link.network.alias == 'donate'">
                            <img alt="" src="@/assets/icons/ic_adopt.png" v-if="link.network.alias == 'adopt'">
                            <img alt="" src="@/assets/icons/ic_trustpilot.svg" v-if="link.network.alias == 'trustpilot'">
                            <img alt="" src="@/assets/icons/ic_capterra.svg" v-if="link.network.alias == 'capterra'">
                            <div>{{link.network.name}}</div>
                        </div>
                    </div>
                    <div class="block-btn__wrapper" @click="showGiveawayPopup" v-if="giveaway.enabled">
                        <div class="block-btn giveaway" :class="{active: giveaway.participates}">
                            <div class="giveaway-text__wrapper" v-if="!accessToken">
                                <div v-if="giveaway.giveaway_title == 'jbar'">
                                    <div class="giveaway-text">{{ translate('ambassadorBtn_title') }}</div>
                                    <div class="giveaway-text">{{ translate('ambassadorBtn_subtitle') }}</div>
                                </div>
                                <div v-if="giveaway.giveaway_title == 'm&k'">
                                    <div class="giveaway-text">JOIN M&K GIVEAWAY CONTEST</div>
                                </div>
                            </div>
                            <div class="giveaway-text__wrapper" v-else>
                                <div v-if="giveaway.giveaway_title == 'jbar'">
                                    <div class="giveaway-text">{{ translate('welcomeAmbassador') }}</div>
                                </div>
                                <div v-if="giveaway.giveaway_title == 'm&k'">
                                    <div class="giveaway-text">YOUR M&K GIVEAWAY</div>
                                    <div class="giveaway-text">CONTEST RULES</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a href="https://air-vote.com/" target="_blank" class="footer-link" :class="{hide: phoneWindowSizeSE}">
                {{translate('powered_by')}}
            </a>
            <div v-if="testTemplateBlocksEnabled" style="height: 44px; background-color: #6D6D6D; width: 100%;"></div>
        </div>
        <Dino :settings="dinoSettings"></Dino>
        <DinoButton :settings="{onClickHandler: dinoBtnClick}"/>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import rateMixin from '@/mixins/rateMixin';
import errorMixin from '@/mixins/errorMixin';
import logAnalyticsEvent from '@/helpers/analytics'
import {isValidUrl} from '@/helpers/customValidators'
import config from '@/api/config';
import giveawayModal from "../widgets/giveawayModal";
import profileIcon from "../voteFlow/widgets/profileIcon.vue";
import socialReviewBtnFlow from "../voteFlow/widgets/socialReviewBtnFlow.vue";
import Dino from "../widgets/Dino";
import DinoButton from "@/components/widgets/DinoButton";
import publicReviewPopup from "@/components/widgets/publicReviewPopup";

export default {
    name: 'ThanksCreateNote',
    components: {DinoButton, giveawayModal, profileIcon, socialReviewBtnFlow, Dino, publicReviewPopup},
    mixins: [mixin, errorMixin, rateMixin],

    data() {
        return {
            testTemplateBlocksEnabled: false,
            place_img: '',
            place_info: {
                place: {
                    name: '',
                },
                question: ''
            },
            socialModal: false,
            rate_id: this.$route.params.number,
            giveawayModalSettings: null,
            socialReviewBtnFlowSettings: {},
            phoneWindowSizeSE: null,
            dinoSettings: null,
            profileIconSettings: {
                question_uid: null,
            },
            publicReviewPopupSettings: null,
        }
    },
    watch: {
        isAuthorized(newValue) {
            if (!newValue) {
                this.$store.commit('rate/clearGiveaway')
            }
        },
        'rate_id'(newValue) {
            this.$store.commit('rate/setRateValue', newValue)
        },
    },
    computed: {
        ...mapState({
            accessToken: state => state.auth.accessToken,
        }),
        ...mapGetters({
            giveaway: 'rate/getGiveaway',
            isAuthorized: 'auth/isAuthorized',
        }),
    },
    methods: {
        ...mapActions({
            sendSocialClick: 'rate/sendSocialClick',
            fetchQuestionInfo: 'rate/fetchQuestionInfo',
        }),

        onAirVoteLogoClick() {
            window.open(`${config.siteUrl}/${this.$ml.current}`, '_blank').focus()
        },

        onPlaceNameClick() {
            logAnalyticsEvent('thx_vote_screen_place_title_click')
            this.openSiteUrl()
        },

        onPlaceImageClick() {
            logAnalyticsEvent('thx_vote_screen_place_img_click')
            this.openSiteUrl()
        },

        openSiteUrl() {
            let url = this.place_info.place.site_url
            if (isValidUrl(url)) {
                window.open(url, '_blank')
            }
        },
        openSocialLink(link) {
            logAnalyticsEvent('thank_create_note_screen_item_click')
            this.sendSocialClickToServer(this.$route.params.rateUid, link.uid)
            window.open(link.url, '_blank');
        },

        onQuestionNameClick() {
            logAnalyticsEvent('thx_vote_screen_question_title_click')
        },

        showGiveawayPopup() {
            logAnalyticsEvent('thx_vote_screen_giveaway_click')
            this.giveawayModalSettings = {
                showCancelButton: false,
                hideOkButton: true,
                place_info: this.place_info,
                currentVoteUid: this.$route.params.rateUid,
                question_id: this.$route.params.questionId,
                onCancelHandler: () => {
                    if(this.giveaway.giveaway_title == 'm&k') this.showPublicReviewPopup()
                },
            }
        },

        showPublicReviewPopup() {
            this.publicReviewPopupSettings = {
                place_links: this.place_info.place.links,
                onLinkClickHandler: this.openSocialLink
            }
        },
        dinoBtnClick() {
            logAnalyticsEvent('tfv_play_dino_clk')
            this.showDino()
        },

        showDino() {
            this.dinoSettings = {
                source: 'tfv'
            }
        },

    },
    async mounted() {
        let questionUid = this.$route.params.questionId
        this.$store.commit('auth/setQuestionUid', questionUid)
        if (this.isAuthorized) await this.fetchUserInfo()
        this.phoneWindowSizeSE = window.matchMedia('(max-width: 321px)').matches
        this.getRateInfo(questionUid)
        this.$store.commit('rate/setQuestionUid', questionUid)
        this.$store.commit('rate/setRateValue', this.$route.params.number)
        this.$store.commit('rate/setRateUid', this.$route.params.rateUid)
        console.log(`test kek lol omg this.$route.params.number: ${this.$route.params.number}`)
        console.log(`test kek lol omg this.$route.params.rateUid: ${this.$route.params.rateUid}`)
        this.profileIconSettings.question_uid = questionUid;

        try {
            let qInfo = (await this.fetchQuestionInfo({question_id: questionUid})).data
            console.log(`qInfo:`, qInfo)
            let q = qInfo.question.second_level_details_config
        }catch (e){
            //todo?
        }

        // this.showDino()
    }
}
</script>

<style scoped>
.logo {
    display: block;
}

.socialReviewBtnFlow {
    margin-bottom: 10px;
}

.list-view {
    background: #2F2F2F;
    border-radius: 0;
    font-size: 1.1em;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.7em;
}

.list-view span {
    margin-right: .4em;
    line-height: normal;
}

.tkank-note {
    /*height: 100vh;*/
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    max-height: 900px;
    max-width: 500px;
    margin: auto;
    border-radius: 4px;
    box-shadow: 0 10px 11px 0 rgba(0, 0, 0, 0.11);
}

.thank-title-1 {
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 0px;
}

.thank-title-2 {
    font-size: 16px;
    text-align: center;
}

.thank-title-2.m-k {
    padding-left: 16px;
    padding-right: 16px;
}

.thank-title-2 span {
    display: block;
}

.footer-link {
    margin-bottom: 16px;
}
.giveaway-text__wrapper {
    text-align: center;
}

</style>
